export default "__VITE_ASSET__CbdddQlt__"